import { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';

import { StoreContext } from '../../store';
import { getNewsletterById } from '../../api';
import { FaChevronLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa6";

const Newsletter = () => {
  const { state, navigate, actions } = useContext(StoreContext);
  const { announcements } = state;
  console.log('Current announcements:', announcements);
  const [newsletter, setNewsletter] = useState({});
  const { id } = useParams();

  const fetchNewsLetter = async () => {
    try {
      const response = await getNewsletterById(id);
      console.log('Fetching newsletter with ID:', id);
      setNewsletter(response);
      console.log('Fetched newsletter:', response);
    } catch (error) {
      console.error("Error fetching newsletters:", error);
      return [];
    }
  };

  useEffect(() => {
    if (announcements.length === 0) {
       const fetchData = async () => {
        await actions.fetchAllNewsletters();
      };
      fetchData();
    }
  }, []);

  useEffect(() => {
    if (id) {
      fetchNewsLetter();
    }
  }, [id]);

  // Find current, previous, and next newsletter from announcements, rotating the list
  const currentIndex = announcements.findIndex(item => String(item.id) === String(id));
  const prevNewsletter =
    announcements.length > 0
      ? announcements[(currentIndex - 1 + announcements.length) % announcements.length]
      : null;
  const nextNewsletter =
    announcements.length > 0
      ? announcements[(currentIndex + 1) % announcements.length]
      : null;

  return (
    <div className='news-page-container w-full h-fit p-8 md:p-16 leading-8'>
      <article className='max-w-[100%] md:max-w-[85%] mx-auto'>
        <div className='text-3xl md:text-4xl text-center mb-8'>{newsletter?.title}</div>
        <div dangerouslySetInnerHTML={{ __html: newsletter?.content }} />
      </article>
      <div className='flex justify-between mt-8 max-w-[100%] md:max-w-[85%] mx-auto font-medium text-sm md:text-2xl'>
        <div
          className="cursor-pointer flex items-center gap-2 max-w-[50%]"
          onClick={() => prevNewsletter && navigate(`/newsletter/${prevNewsletter.id}`)}
        >
          <FaChevronLeft />
          <div>{prevNewsletter?.title}</div>
        </div>
        <div
          className="cursor-pointer flex items-center gap-2 max-w-[50%]"
          onClick={() => nextNewsletter && navigate(`/newsletter/${nextNewsletter.id}`)}
        >
          <div>{nextNewsletter?.title}</div>
          <FaChevronRight />
        </div>
      </div>
    </div>
  )
};

export default Newsletter;